import Departments from '../../../models/departments';

export const isCategorySomeDepartment = (categoryName): boolean => {
  return (
    !categoryName ||
    Object.keys(Departments.names)
      .map(department => department.replace(/-/g, ' '))
      .includes(categoryName.toLowerCase())
  );
};

export const isHomeCategory = (department, category): boolean => {
  return Departments.getHomeInternalName() === department || category.department.id === Departments.getHomeId();
};

export const overrideCategory = (department, categoryName) => {
  const departmentWithoutDashes = department.replace(/-/g, ' ').toLowerCase();
  if (departmentWithoutDashes === categoryName.toLowerCase()) {
    return 'Clothing';
  }
  return categoryName;
};
